<template>
  <div class="custom-margin">
    <v-row dense class="ma-2">
      <div>
        <v-btn color="#141E46" class="white--text" @click="addStaff"> 建立新員工 </v-btn>
      </div>
    </v-row>
    <div class="ma-2 table-row">
      <v-data-table
        :headers="headers"
        :items="records"
        :items-per-page="-1"
        class="pa-2 table"
        disable-sort
        hide-default-footer
        dense
        no-data-text="暫無員工資料"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span class="hover-effect" @click="editStaff(item)">
            {{ item.name }}
          </span>
        </template>
        <template v-slot:[`item.gender`]="{ item }">
          <span
            v-if="item.gender == null"
            class="text-add hover-add"
            @mouseover="colorItems.gender = '#258525'"
            @mouseout="colorItems.gender = '#8d8d8d'"
            @click="editStaff(item)"
          >
            編輯
          </span>
          <span v-else class="hover-effect" @click="editStaff(item)">
            {{ item.gender == '1' ? '男' : '女' }}
          </span>
        </template>
        <template v-slot:[`item.phone`]="{ item }">
          <span
            v-if="item.phone == null"
            class="text-add hover-add"
            @mouseover="colorItems.phone = '#258525'"
            @mouseout="colorItems.phone = '#8d8d8d'"
            @click="editStaff(item)"
          >
            編輯
          </span>
          <span v-else class="hover-effect" @click="editStaff(item)">
            {{ item.phone }}
          </span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span
            v-if="item.type == null"
            class="text-add hover-add"
            @mouseover="colorItems.type = '#258525'"
            @mouseout="colorItems.type = '#8d8d8d'"
            @click="editStaff(item)"
          >
            編輯
          </span>
          <span v-else class="hover-effect" @click="editStaff(item)">
            {{ item.type }}
          </span>
        </template>
        <template v-slot:[`item.start_date`]="{ item }">
          <span
            v-if="item.start_date == null"
            class="text-add hover-add"
            @mouseover="colorItems.start_date = '#258525'"
            @mouseout="colorItems.start_date = '#8d8d8d'"
            @click="editStaff(item)"
          >
            編輯
          </span>
          <span v-else class="hover-effect" @click="editStaff(item)">
            {{ item.start_date }}
          </span>
        </template>
        <!-- <template v-slot:[`item.end_date`]="{ item, index }">
          <span
            v-if="item.end_date == null"
            class="text-add hover-add"
            @mouseover="colorItems.end_date = '#258525'"
            @mouseout="colorItems.end_date = '#8d8d8d'"
            @click=editStaff(item)
          >
            編輯
          </span>
          <span v-else class="hover-effect" @click="editStaff(item)">
            {{ item.end_date }}
          </span>
        </template> -->
        <template v-slot:[`item.status`]="{ item }">
          <span
            v-if="item.status == null"
            class="text-add hover-add"
            @mouseover="colorItems.status = '#258525'"
            @mouseout="colorItems.status = '#8d8d8d'"
            @click="editStaff(item)"
          >
            編輯
          </span>
          <span v-else class="hover-effect" @click="editStaff(item)">
            {{ item.status ? '啟用' : '停用' }}
          </span>
        </template>
        <template v-slot:[`item.driver_license`]="{ item }">
          <span
            v-if="item.driver_license == null"
            class="text-add hover-add"
            @mouseover="colorItems.driver_license = '#258525'"
            @mouseout="colorItems.driver_license = '#8d8d8d'"
            @click="editStaff(item)"
          >
            編輯
          </span>
          <span v-else class="hover-effect" @click="editStaff(item)">
            {{ item.driver_license ? '有' : '無' }}
          </span>
        </template>
        <template v-slot:[`item.institution`]="{ item }">
          <div
            v-if="!item.institution_name || item.institution_name.length === 0"
            class="text-add hover-add"
            @mouseover="colorItems.institution = '#258525'"
            @mouseout="colorItems.institution = '#8d8d8d'"
            @click="editStaff(item)"
          >
            編輯
          </div>
          <div v-else class="hover-effect institution-list" @click="editStaff(item)">
            <div
              v-for="(institution, index) in item.institution_name"
              :key="index"
              class="institution-item"
            >
              {{ institution }}
            </div>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog persistent v-model="dialog" max-width="800px">
      <v-card class="py-4">
        <v-card-title>
          <div v-if="isEdit">員工資料編輯 - {{ editedData.editedName }}</div>
          <div v-else>建立新員工</div>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-text-field
                  dense
                  outlined
                  label="姓名"
                  v-model="editedData.editedName"
                  :rules="[(v) => !!v || '*必填']"
                  hide-details=""
                ></v-text-field
              ></v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  dense
                  outlined
                  hide-details=""
                  label="身份證字號"
                  v-model="editedData.editedIdNumber"
                  :rules="[(v) => !!v || '*必填']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  dense
                  outlined
                  hide-details=""
                  label="生日(yyyy-mm-dd)"
                  v-model="formattedBirth"
                  maxlength="10"
                  :rules="[(v) => !!v || '*必填']"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider />
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-select
                  dense
                  outlined
                  hide-details=""
                  label="性別"
                  v-model="editedData.editedGender"
                  :items="genderOptions"
                  :rules="[(v) => !!v || '*必填']"
                  :menu-props="{
                    top: false,
                    bottom: true,
                    left: false,
                    right: false,
                    offsetY: true,
                    maxHeight: 300,
                  }"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  dense
                  outlined
                  hide-details=""
                  label="電話"
                  v-model="editedData.editedPhone"
                  :rules="[(v) => !!v || '*必填']"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-select
                  dense
                  outlined
                  hide-details=""
                  label="人力類型"
                  v-model="editedData.editedJob"
                  :items="jobOptions"
                  :rules="[(v) => !!v || '*必填']"
                  :menu-props="{
                    top: false,
                    bottom: true,
                    left: false,
                    right: false,
                    offsetY: true,
                    maxHeight: 300,
                  }"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  dense
                  outlined
                  hide-details=""
                  label="到職日(yyyy-mm-dd)"
                  v-model="formattedStartDate"
                  maxlength="10"
                  :rules="[(v) => !!v || '*必填']"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="4">
                <v-text-field
                  dense
                  outlined
                  hide-details=""
                  label="離職日"
                  v-model="end_date"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="4">
                <v-select
                  dense
                  outlined
                  hide-details=""
                  label="職業駕照"
                  :items="driverLicenseOptions"
                  v-model="editedData.editedDriverLicense"
                  :menu-props="{
                    top: false,
                    bottom: true,
                    left: false,
                    right: false,
                    offsetY: true,
                    maxHeight: 300,
                  }"
                ></v-select> </v-col
            ></v-row>
            <v-divider />
            <v-row dense>
              <v-col cols="12" sm="4">
                <v-select
                  dense
                  outlined
                  hide-details=""
                  label="員工狀態"
                  v-model="editedData.editedStatus"
                  :items="statusOptions"
                  :rules="[(v) => (v !== null && v !== undefined) || '*必填']"
                  :menu-props="{
                    top: false,
                    bottom: true,
                    left: false,
                    right: false,
                    offsetY: true,
                    maxHeight: 300,
                  }"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8">
                <v-select
                  dense
                  outlined
                  hide-details=""
                  label="服務機構"
                  v-model="editedData.editedInstitutions"
                  :items="institutionOptions"
                  item-text="institution_name"
                  item-value="institution_code"
                  multiple
                  chips
                  :rules="[(v) => v.length > 0 || '*必填']"
                  :menu-props="{
                    top: false,
                    bottom: true,
                    left: false,
                    right: false,
                    offsetY: true,
                    maxHeight: 300,
                  }"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-row dense class="justify-space-around">
            <v-btn text color="red" @click="dialog = false">取消</v-btn>
            <!-- <v-btn text color="red" @click="dialog = false">拒測</v-btn> -->
            <v-btn text color="green" @click="submit">送出</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import moment from 'moment'
export default {
  data() {
    return {
      headers: [
        {
          text: '姓名',
          value: 'name',
          align: 'center',
          width: '100px',
        },
        { text: '性別', value: 'gender', align: 'center', width: '75px' },
        { text: '電話', value: 'phone', align: 'center', width: '75px' },
        {
          text: '人力類型',
          value: 'type',
          align: 'center',
          width: '75px',
        },
        { text: '到職日', value: 'start_date', align: 'center', width: '75px' },
        // {
        //   text: "離職日",
        //   value: "end_date",
        //   align: "center",
        //   width: "75px",
        // },
        {
          text: '職業駕照',
          value: 'driver_license',
          align: 'center',
          width: '75px',
        },
        { text: '服務機構', value: 'institution', align: 'center', width: '250px' },
        { text: '啟用狀態', value: 'status', align: 'center', width: '75px' },
      ],
      records: [
        // {
        //   name: "蘇凱負",
        //   type: "照服員",
        //   start_date: "2024-01-01",
        //   gender: "1",
        //   phone: "0955884753",
        //   driver_license: true,
        //   status: true,
        // },
        // {
        //   name: "吳佳西",
        //   type: "司機",
        //   start_date: "2023-06-04",
        //   gender: "1",
        //   phone: "0987987487",
        //   driver_license: true,
        //   status: true,
        // },
        // {
        //   name: "孫小美",
        //   type: "護理師",
        //   start_date: "2023-06-04",
        //   gender: "2",
        //   phone: "0978678978",
        //   driver_license: false,
        //   status: false,
        // },
      ],
      dialog: false,
      isEdit: false,
      staff_id: '',
      case_id: '',
      index: '',
      caseName: '',
      time: '',
      phone: '',
      end_date: '',
      driver_license: '',
      group_2: '',
      colorItems: {
        type: '#8d8d8d',
        start_date: '#8d8d8d',
        gender: '#8d8d8d',
        phone: '#8d8d8d',
        end_date: '#8d8d8d',
        driver_license: '#8d8d8d',
        status: '#8d8d8d',
        institution: '#8d8d8d',
        group_1: '#8d8d8d',
        group_2: '#8d8d8d',
      },
      menu: false,
      selectedDate: new Date(),
      jobOptions: [],
      genderOptions: [
        { text: '男', value: 1 },
        { text: '女', value: 2 },
      ],
      driverLicenseOptions: [
        { text: '有', value: true },
        { text: '無', value: false },
      ],
      statusOptions: [
        { text: '啟用', value: true },
        { text: '停用', value: false },
      ],
      institutionOptions: [],
      editedData: {
        editedEmployeeID: null,
        editedName: null,
        editedIdNumber: null,
        editedBirth: null,
        editedGender: null,
        editedPhone: null,
        editedJob: null,
        editedStartDate: null,
        editedDriverLicense: false,
        editedStatus: false,
        editedInstitutions: [],
      },
    }
  },
  methods: {
    async getList() {
      // console.log(this.formattedDate);
      let config = {
        method: 'get',
        url: `/api/attendance/list_employee`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        console.log(res.data.data)
        this.records = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    initialInputData() {
      for (let key in this.editedData) {
        if (key === 'editedInstitutions') {
          this.editedData[key] = []
        } else {
          this.editedData[key] = null
        }
      }
    },
    async getJob() {
      // console.log(this.formattedDate);

      let config = {
        method: 'get',
        url: `/api/attendance/list_job`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        // console.log(res.data.data);
        this.jobOptions = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getInstitution() {
      let config = {
        method: 'get',
        url: `/api/attendance/list_institution`,
        header: {},
      }
      try {
        let res = await axios.request(config)
        this.institutionOptions = res.data.data
      } catch (error) {
        console.log(error)
      }
    },
    async submit() {
      if (!this.$refs.form.validate()) {
        alert('請確認必填選項')
        return
      }

      let data = qs.stringify({
        name: this.editedData.editedName,
        phone: this.editedData.editedPhone,
        birth: this.editedData.editedBirth,
        gender: this.editedData.editedGender,
        id_num: this.editedData.editedIdNumber,
        hire_date: this.editedData.editedStartDate,
        status: this.editedData.editedStatus,
        drive_license: this.editedData.editedDriverLicense,
        job: this.editedData.editedJob,
        institution_code: Array.isArray(this.editedData.editedInstitutions)
          ? this.editedData.editedInstitutions
              .filter((code) => code && code.trim() !== '')
              .join(', ')
          : '',
      })
      let config = {}
      if (this.isEdit === true) {
        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/api/attendance/edit_employee/' + this.editedData.editedEmployeeID + '/',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: data,
        }
      } else {
        config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/api/attendance/create_employee',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          data: data,
        }
      }

      try {
        let res = await axios.request(config)
        console.log(res.data)
        this.dialog = false
        this.getList() // 重新載入資料
      } catch (error) {
        console.log(error)
      }
    },
    addStaff() {
      this.isEdit = false
      this.initialInputData()
      this.dialog = true
    },
    editStaff(item) {
      this.isEdit = true
      this.editedData.editedEmployeeID = item.employee_id
      this.editedData.editedName = item.name
      this.editedData.editedPhone = item.phone
      this.editedData.editedBirth = item.birth
      this.editedData.editedGender = item.gender
      this.editedData.editedIdNumber = item.id_number
      this.editedData.editedStartDate = item.start_date
      this.editedData.editedStatus = item.status
      this.editedData.editedDriverLicense = item.driver_license
      this.editedData.editedJob = item.type
      if (Array.isArray(item.institution_code)) {
        this.editedData.editedInstitutions = item.institution_code.filter(
          (code) => code && code.trim() !== ''
        )
      } else if (item.institution_code && typeof item.institution_code === 'string') {
        this.editedData.editedInstitutions = item.institution_code
          .split(', ')
          .filter((code) => code.trim() !== '')
      } else {
        this.editedData.editedInstitutions = []
      }
      this.dialog = true
    },
  },
  computed: {
    formattedBirth: {
      get() {
        const birth = this.editedData.editedBirth || ''
        return birth
      },
      set(newVal) {
        if (!newVal) {
          this.editedData.editedBirth = null
          return
        }
        const digits = newVal.replace(/\D/g, '')
        if (digits.length === 8) {
          this.editedData.editedBirth = `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(
            6
          )}`
        } else {
          this.editedData.editedBirth = newVal
        }
      },
    },
    formattedStartDate: {
      get() {
        const startDate = this.editedData.editedStartDate || ''
        return startDate
      },
      set(newVal) {
        if (!newVal) {
          this.editedData.editedStartDate = null
          return
        }
        const digits = newVal.replace(/\D/g, '')
        if (digits.length === 8) {
          this.editedData.editedStartDate = `${digits.slice(0, 4)}-${digits.slice(
            4,
            6
          )}-${digits.slice(6)}`
        } else {
          this.editedData.editedStartDate = newVal
        }
      },
    },
  },
  mounted() {
    this.getList()
    this.getJob()
    this.getInstitution()
  },
  created() {
    let staff = localStorage.getItem('staff')
    this.staff_id = JSON.parse(staff).id
  },
}
</script>

<style scoped>
.hover-effect:hover {
  cursor: pointer;
  color: #4477ce;
}
.hover-add:hover {
  cursor: pointer;
  color: #258525;
}
.custom-margin {
  overflow-x: auto !important;
  /* max-width: fit-content;。 */
}

.table-row {
  width: 90vw;
}

.table {
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}

.text-add {
  font-size: 12px;
  color: #8d8d8d;
}

.institution-list {
  text-align: center;
}

.institution-item {
  padding: 2px 0;
  line-height: 1.2;
}
</style>
